import { IApplicationRouterExtension } from '../../../application/ApplicationRouterExtensions';
import { UserSystemRoleModelPermissionMap } from '../../../service/systemRole/entity/actions/UserSystemRoleModelPermissionMap';
import { ILocalization } from '../application/language/ILocalization';
import { LearningRoutes } from '../constants/LearningRoutes';
import { LearningAdminPage } from '../LearningAdminPage';
import { LearningUserPage } from '../LearningUserPage';
import LearningUnitPreviewPage from '../view/admin/page/LearningUnitPreviewPage';
import { LearningUserRatingPage } from '../view/admin/page/learningUserRatingPage/LearningUserRatingPage';
import { PassingPage } from '../view/admin/page/passing/Passing';
import { UnitPage } from '../view/admin/page/unit/UnitPage';
import { LearningAnalyticsPage } from '../view/analytics/LearningAnalyticsPage';

type IArgs = {
  i18n: ILocalization
}
export const LearningRouter = ({ i18n: { translate } }: IArgs): IApplicationRouterExtension[] => [
  {
    path: LearningRoutes.LearningAdmin,
    pageTitle: translate('learningUserPage.learningTitle'),
    component: LearningAdminPage,
    allowedPermissions: [UserSystemRoleModelPermissionMap['global-allow-any']],
    fullHeight: true,
  },
  {
    path: LearningRoutes.LearningUnitCreate,
    pageTitle: translate('createUnit.pageTitle'),
    component: UnitPage,
    allowedPermissions: [UserSystemRoleModelPermissionMap['global-allow-any']],
    fullHeight: true,
  },
  {
    path: LearningRoutes.LearningUnitEdit,
    pageTitle: translate('phrases.editUnit'),
    component: UnitPage,
    allowedPermissions: [UserSystemRoleModelPermissionMap['global-allow-any']],
    fullHeight: true,
  },
  {
    path: LearningRoutes.LearningUser,
    pageTitle: translate('learningUserPage.learningTitle'),
    component: LearningUserPage,
    allowedPermissions: [],
    fullHeight: true,
  },
  {
    path: LearningRoutes.LearningUnitPassing,
    pageTitle: translate('phrases.passing'),
    component: PassingPage,
    allowedPermissions: [],
    showNavBar: false,
    fullHeight: true,
  },
  {
    path: LearningRoutes.LearningUserRating,
    pageTitle: translate('phrases.userRating'),
    component: LearningUserRatingPage,
    allowedPermissions: [UserSystemRoleModelPermissionMap['global-allow-any']],
    fullHeight: true,
  },
  {
    path: LearningRoutes.LearningAdminAnalytics,
    pageTitle: translate('navigation.leaderBoards'),
    component: LearningAdminPage,
    allowedPermissions: [],
    fullHeight: true,
    overflowY: true,
  },
  {
    path: LearningRoutes.LearningUserAnalytics,
    pageTitle: translate('navigation.leaderBoards'),
    component: LearningUserPage,
    allowedPermissions: [],
    fullHeight: true,
    overflowY: true,
  },
  {
    path: LearningRoutes.LearningUnitPreview,
    pageTitle: translate('phrases.preview'),
    component: LearningUnitPreviewPage,
    showNavBar: false,
    showPaddings: false,
    allowedPermissions: [UserSystemRoleModelPermissionMap['global-allow-any']],
    fullHeight: true,
  },
  {
    path: LearningRoutes.LearningAnalyticsTab,
    pageTitle: translate('navigation.leaderBoards'),
    component: LearningAnalyticsPage,
    showNavBar: true,
    showPaddings: true,
    allowedPermissions: [UserSystemRoleModelPermissionMap['global-allow-any']],
    fullHeight: true,
  },
];
